import axios from 'axios'
import store from '@/store'

export default() => {
  let token = store.state.token || null;
  axios.defaults.headers.common['Authorization'] = "Bearer " + token;

  return axios.create({
    baseURL: process.env.VUE_APP_HOST || 'http://localhost:3333',
    timeout: 5900,
  })
}